import { HttpContextToken } from '@angular/common/http';

// When set to true in a request's HttpContext, the auth interceptor will skip
// adding Authorization header and refresh logic.
export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);
